import React from 'react';
import { MapContainer, TileLayer, Circle, Popup } from 'react-leaflet';
import "./App.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

class Location extends React.Component {
  async componentWillMount() {
    await fetch(`https://tick.thedata.place/location/locations/${this.props.id}`)
        .then(response => response.json())
        .then(json => this.setState(json));
  }

  render() {
    return (
           <div>
            <h4>{this.props.id}</h4>
            <TableContainer style={{width:250}} component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell component="th">Gateway</TableCell>
                        <TableCell component="th">RSSI</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state?.gateways.map((gw) => (
                        <TableRow>
                            <TableCell>{gw.id}</TableCell>
                            <TableCell>{gw.rssi}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>
          </div>
        );
  }
}

const redOptions = { color: 'red', fillColor: 'red' }
const greenOptions = { color: 'green', fillColor: 'green' }
const amberOptions = { color: 'orange', fillColor: 'orange' }

class App extends React.Component {

async updateCoverage() {
    const data = await fetch('https://tick.thedata.place/location/locations')
        .then(response => response.json());
    this.setState({coverage: data});
};

getOptions(rssi) {
    if (rssi < -120) {
        return redOptions;
    } else if (rssi < -99) {
        return amberOptions;
    } else if ( rssi > -100) {
        return greenOptions;
    };
}

componentWillMount() {
    this.updateCoverage();
}

render() {
	  return (
	    <div>
	        <p><center><Button variant="contained" color="primary" onClick={() => this.updateCoverage()}>Refresh Map</Button></center></p>
			<MapContainer center={[50.39003250086778, -4.143949225938556]} zoom={13}>
			  <TileLayer
			    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			  />;
			  {this.state?.coverage.map((location) => (
			      <Circle
	                center={[location.latitude, location.longitude]}
	                pathOptions={this.getOptions(location.rssi)}
	                radius={18}
	                stroke={true}
	                key={location.geohash}
	                >
	                <Popup><Location id={location.geohash} /></Popup>
	             </Circle>
			  ))}
			</MapContainer>
		</div>
	  );
	}
}

export default App;
